import React from 'react'

export default function PrivacyPolicy() {
    return (
        <div className='px-3 md:px-10 text-justify my-5'>
            <div className='text-2xl font-bold text-red-800 text-center my-10'>Your Privacy Matters to Us</div>

            Welcome to QOC, where your educational journey is our top priority. At QOC, we are committed
            to providing a secure and transparent learning environment that respects your privacy. Our
            Privacy Policy outlines how we collect, use, and protect your personal information to ensure
            your experience with us is both enriching and secure.


            <p className='text-xl font-bold text-red-700 my-7'>Intellectual Property at QOC</p>
            The QOC platform, including its website and all original content, features, and functionalities, is
            the intellectual property of Quorum of Collaborative-learning (QOC). These assets are
            safeguarded by a spectrum of international laws, including but not limited to copyright,
            trademark, patent, trade secret, and other proprietary rights.
            At QOC, we value the creative and intellectual contributions that make our platform unique. We
            are dedicated to upholding and protecting the intellectual property rights associated with our
            content, ensuring a secure and innovative learning environment for all users.
            Any unauthorized use, reproduction, or distribution of QOC's intellectual property is strictly
            prohibited. We encourage a respectful and collaborative approach to learning, respecting the
            rights of content creators and contributors. Join us on QOC, where intellectual property is
            cherished and safeguarded, fostering an environment where knowledge is valued and
            protected.


            <p className='text-xl font-bold text-red-700 my-7'>What Information Do We Collect?</p>
            At QOC, we may collect information necessary to tailor our services to your unique needs. This
            includes, but is not limited to, personal details such as your name, date of birth, contact
            information, and academic details. We may provide you with a username and password for
            secure access, ensuring the confidentiality of your information.


            <p className='text-xl font-bold text-red-700 my-7'>Why Do We Collect and How Do We Use Your Information?</p>
            The information we collect is used to personalize your learning experience, improve our
            website, respond to customer service requests, administer contests or promotions, process
            transactions, and gather feedback. We employ robust security measures, including regular
            malware scanning and encryption technology, to protect your personal information. QOC
            collects and uses your personal information to enhance your learning experience, provide
            personalized tutorial sessions, improve our services, and respond to your requests promptly. We
            may also use this information for website and service enhancements, as well as for marketing
            and promotional purposes. While you have the option to withhold certain information, doing so
            may limit your access to our services.


            
            <p className='text-xl font-bold text-red-700 my-7'>Storage and Sharing of Information</p>

            Your privacy is of utmost importance to us. QOC takes reasonable physical, technical, and
            organizational measures to safeguard the information we collect. We do not share your personal
            contact information with unaffiliated third parties. However, we may use the information for
            registration, account management, research, statistical analysis, and business intelligence.
            Please note that online disclosure of personal information carries inherent risks, and we
            encourage you to use QOC responsibly.
            <p className='text-xl font-bold text-red-700 my-7'> Tutoring lesson </p>
            During tutoring sessions, we prioritize the privacy of your information. While limited information
            may be shared with tutors to enhance the learning experience, we strictly advise against sharing
            sensitive details. Parental guidance is recommended for students below 12 years old. QOC is
            not liable for any intentional information provided by users during sessions.
            <p className='text-xl font-bold text-red-700 my-7'>Cookies</p>
            QOC may use cookies to enhance your website experience, remember preferences, and
            compile aggregate data for better services. You can manage cookie settings in your browser,
            but disabling them may affect site functionality.
            <p className='text-xl font-bold text-red-700 my-7'>Third-Party Disclosure and Links</p>
            We do not sell or trade your personally identifiable information. QOC does not include third-party
            products or services on our website. We are committed to notifying and taking responsive
            actions in the event of a data breach.
            <p className='text-xl font-bold text-red-700 my-7'>Modifications and Consent</p>
            QOC reserves the right to modify this policy. It is your responsibility to stay informed of any
            changes. By using our services, you agree to our Privacy Policy and acknowledge that it is an
            integral part of our Terms of Service.
            <p className='text-xl font-bold text-red-700 my-7'>Changes to Our Policy</p>
            Any changes to our privacy policy will be promptly communicated on our website.
            At QOC, your trust is paramount. Join us on a collaborative learning journey, where education
            and privacy coexist harmoniously.

            


        </div>
    )
}
